import validate from 'validate.js';
const transformToInt = (value) => {
  if (value instanceof Date) {
    return value.getTime();
  } else if (typeof value === 'string') {
    return parseFloat(value)
  } else {
    return value;
  }
};

export default function (value, options, key, attributes) {
  options = Object.assign({}, this.options, validate.isString(options) ? {key: options} : options);

  let val = transformToInt(value);
  let targetKey = options.key;
  let targetVal = transformToInt(attributes[targetKey]);

  if (targetVal !== null && targetVal >= val) {
    return options.message || this.message || `has to be grater than ${validate.prettify(targetKey)}`;
  }
}



// WEBPACK FOOTER //
// ./src/utilites/validate/greaterThan.js